export enum BusinessRulesSelectMultipleOperator {
  contains_all = 'contains_all',
  is_contained_by = 'is_contained_by',
  shares_at_least_one_element_with = 'shares_at_least_one_element_with',
  shares_exactly_one_element_with = 'shares_exactly_one_element_with',
  shares_no_elements_with = 'shares_no_elements_with',
}

enum BusinessRulesSelectOperator {
  contains = 'contains',
  does_not_contain = 'does_not_contain',
}

export enum BusinessRulesStringOperator {
  contains = 'contains',
  ends_with = 'ends_with',
  equal_to = 'equal_to',
  equal_to_case_insensitive = 'equal_to_case_insensitive',
  matches_regex = 'matches_regex',
  non_empty = 'non_empty',
  starts_with = 'starts_with',
}

export enum BusinessRulesInputType {
  none = 'none',
  numeric = 'numeric',
  select = 'select',
  select_multiple = 'select_multiple',
  text = 'text',
}

export enum BusinessRulesRuleName {
  country = 'country',
  email = 'email',
  is_available = 'is_available',
  location = 'location',
  name = 'name',
  question_choice = 'question_choice',
  segments = 'segments',
  url = 'url',
  url_title = 'url_title',
}

export type BusinessRulesVariableTypeOperatorNameMap = {
  [BusinessRulesVariableType.string]: BusinessRulesStringOperator;
  [BusinessRulesVariableType.select]: BusinessRulesSelectOperator;
  [BusinessRulesVariableType.selectMultiple]: BusinessRulesSelectMultipleOperator;
};

export type BusinessRulesVariableTypeOperatorInputTypeMap = {
  [BusinessRulesVariableType.string]: BusinessRulesInputType.text;
  [BusinessRulesVariableType.select]: BusinessRulesInputType.select;
  [BusinessRulesVariableType.selectMultiple]: BusinessRulesInputType.select_multiple;
};

export interface BusinessRulesVariableTypeOperator<E extends BusinessRulesVariableType> {
  inputType: BusinessRulesVariableTypeOperatorInputTypeMap[E];
  label: string;
  name: BusinessRulesVariableTypeOperatorNameMap[E];
}

export enum BusinessRulesVariableType {
  // boolean = 'boolean',
  // numeric = 'numeric',
  select = 'select',
  selectMultiple = 'selectMultiple',
  string = 'string',
}

export type BusinessRulesVariableTypeOperators = Record<
  BusinessRulesVariableType,
  BusinessRulesVariableTypeOperator<BusinessRulesVariableType>[]
>;

export interface BusinessRulesVariableOption {
  label: string;
  name: string | number;
}

export interface BusinessRulesConditionsSchemaVariable {
  fieldType: BusinessRulesVariableType;
  label: string;
  name: BusinessRulesRuleName;
  options: BusinessRulesVariableOption[];
  entryOnly?: boolean;
}

export interface BusinessRulesConditionsSchema {
  variableTypeOperators: BusinessRulesVariableTypeOperators;
  variables: BusinessRulesConditionsSchemaVariable[];
}

export type BusinessRulesOperators =
  | BusinessRulesStringOperator
  | BusinessRulesSelectOperator
  | BusinessRulesSelectMultipleOperator;

export interface BusinessRulesRule {
  name: BusinessRulesRuleName;
  operator: BusinessRulesOperators;
  value: string | string[];
}

export enum BusinessRulesRuleType {
  all = 'all',
  any = 'any',
}

export type BusinessRulesRuleGroup = {
  [key in BusinessRulesRuleType]: BusinessRulesRule[];
};

export type BusinessRulesGroup = BusinessRulesRule | BusinessRulesRuleGroup;

export type BusinessRulesConditions = {
  [key in BusinessRulesRuleType]: BusinessRulesGroup[];
};

export interface ExplainedBusinessRulesRule extends BusinessRulesRule {
  result: boolean;
}

export type ExplainedBusinessRulesRuleGroup = {
  [key in BusinessRulesRuleType]: ExplainedBusinessRulesRule[];
};

export type ExplainedBusinessRulesGroup =
  | ExplainedBusinessRulesRule
  | ExplainedBusinessRulesRuleGroup;

export type ExplainedBusinessRulesConditions = {
  [key in BusinessRulesRuleType]: ExplainedBusinessRulesGroup[];
};
